export enum MetabaseDasboardId {
    PAYMENT = 21,
    TEMPORARY_REPLACEMENT = 13,
    PERMENANT_REPLACEMENT = 45,
    TRIALS = 44,
    OMS = 224,
    CUSTOMER= 189,
    AREA_DETAILS= 225
}
